import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap, MapLocKeys } from '@cm/core/localization';

export type CPTableDataFilterLoc =
	| 'CPTableDataHideFiltersTooltip'
	| 'CPTableDataShowFiltersTooltip'
	| 'CPTableDataClearFiltersTooltip'
	| 'CPTableDataSearchLabel';

export const cpTableDataFilterLocs: LocDefs<CPTableDataFilterLoc> = {
	CPTableDataHideFiltersTooltip: {
		defaultValue: 'Hide filterable fields',
		description: 'Assistive text displayed on the toggle to hide filterable fields',
		displayPath: 'Data View|Hide Filterable Fields',
		displayType: 'Content',
		shared: true,
		portal: 'CP',
		feature: HubFeature.CandidateAccess,
	},
	CPTableDataShowFiltersTooltip: {
		defaultValue: 'Show filterable fields',
		description: 'Assistive text displayed on the toggle to show filterable fields',
		displayPath: 'Data View|Show Filterable Fields',
		displayType: 'Content',
		shared: true,
		portal: 'CP',
		feature: HubFeature.CandidateAccess,
	},
	CPTableDataClearFiltersTooltip: {
		defaultValue: 'Clear',
		description: 'Assistive text displayed on the clear filters button',
		displayPath: 'Data View|Clear Filters',
		displayType: 'Content',
		shared: true,
		portal: 'CP',
		feature: HubFeature.CandidateAccess,
	},
	CPTableDataSearchLabel: {
		defaultValue: 'Search',
		description: 'Default label for the search field',
		displayPath: 'Data View|Search Field Label',
		displayType: 'Label',
		shared: true,
		portal: 'CP',
		feature: HubFeature.CandidateAccess,
	},
};

export const LOC_KEYS = MapLocKeys<CPTableDataFilterLoc>(cpTableDataFilterLocs);
export type CPTableDataFilterLocType = LocMap<CPTableDataFilterLoc>;
